console.debug("IN THE STAGE CONFIG", import.meta.env.VITE_STAGE)
export const stage: 'ide' | 'dev' | 'test' | 'prod' = import.meta.env.VITE_STAGE;